const RoleEditorView = {
  GENERAL: "GENERAL",
  PERMISSIONS: "PERMISSIONS"
};

export default RoleEditorView;